import { render, staticRenderFns } from "./AddDataList.vue?vue&type=template&id=5fccfd44&scoped=true"
import script from "./AddDataList.vue?vue&type=script&lang=js"
export * from "./AddDataList.vue?vue&type=script&lang=js"
import style0 from "./AddDataList.vue?vue&type=style&index=0&id=5fccfd44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fccfd44",
  null
  
)

export default component.exports